export default "__VITE_ASSET__gJEUxhOh__"